import React, { FC, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../hooks';
import { Circle, StyledSpan } from './tag-item.styled';
import { getConstantName } from '../../../../../utils';

interface Props {
  tag: string;
}

export const TagItem: FC<Props> = observer(({ tag }) => {
  const { constants } = useStore();

  const tagName: string = useMemo(
    () => getConstantName(constants.telephony.Tag, tag),
    [constants.telephony?.Tag?.length, tag]
  );

  return (
    <>
      <Circle value={tag} />
      <StyledSpan>{tagName}</StyledSpan>
    </>
  );
});
